// extracted by mini-css-extract-plugin
export var btn = "P_mB y_ty y_th d_bz d_bP d_bD d_dw";
export var full = "P_xc d_w d_H";
export var hoverStyle = "P_mF";
export var zoom = "P_mG";